import React from "react";
import styles from "./styles/sign-button.module.scss";

type Props = {
  title: string;
  isDisabled?: boolean;
  onClick?: () => void;
};
const SignButton = ({ title, isDisabled, onClick }: Props) => {
  return (
    <div
      className={isDisabled ? styles.disabled : styles.container}
      role="presentation"
      onClick={isDisabled ? undefined : onClick}
    >
      <div className={styles.text}>{title}</div>
    </div>
  );
};

export default SignButton;
